import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-build-message',
  templateUrl: './build-message.component.html',
  styleUrls: ['./build-message.component.scss'],
})
export class BuildMessageComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
